// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_h-1";
export var movingGradient = "_h-4";
export var movingGradientBlock = "_h-2";
export var skeleton = "_h-0";
export var skeletonText = "_h-3";